import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';
import './ErrorMessage.css';

const ErrorMessage = ({ 
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  error,
  onRetry,
  variant = 'danger',
  showDetails = false
}) => {
  return (
    <Alert variant={variant} className="error-message">
      <div className="d-flex align-items-start">
        <div className="error-icon me-3">
          <FaExclamationTriangle />
        </div>
        <div className="flex-grow-1">
          <Alert.Heading className="h5 mb-2">{title}</Alert.Heading>
          <p className="mb-2">{message}</p>
          
          {showDetails && error && (
            <details className="error-details mt-2">
              <summary className="cursor-pointer text-muted small">
                Show technical details
              </summary>
              <pre className="mt-2 p-2 bg-light rounded small">
                {error.message || error.toString()}
              </pre>
            </details>
          )}
          
          {onRetry && (
            <Button 
              variant="outline-danger" 
              size="sm" 
              onClick={onRetry}
              className="mt-3"
            >
              <FaRedo className="me-2" />
              Try Again
            </Button>
          )}
        </div>
      </div>
    </Alert>
  );
};

export default ErrorMessage;
